import Vue from 'vue'
import Router from 'vue-router'
import Main from '../components/Main.vue'
import Register from '../components/Register.vue'
import About from '../components/About.vue'
import BlogMain from '../components/blog/BlogMain.vue'

Vue.use(Router)

const blogOfLinks = window.location.host === 'andrew.ooo' || window.location.host.indexOf('localhost') > -1
const title = (blogOfLinks) ? 'andrew.ooo - Small pieces of the Internet' : 'Last 365 Days Of My Twenties'
const url = (blogOfLinks) ? 'andrew.ooo' : 'pursuing.business'
const desc = (blogOfLinks) ? 'Blog of inspiring links' : 'Starting own business from zero'

const router = new Router({
    mode: 'history',
    routes: [
        { path: '/about', component: About },
        { path: '/rega', component: Register },
        { path: '/blog', component: BlogMain },
        { path: '/links', component: Main },
        { path: '/post/:id', component: BlogMain },
        { path: '/blog/post/:id', component: BlogMain },
        { path: '/', component: (blogOfLinks) ? Main : BlogMain,
          meta: {
            title: title,
            metaTags: [
              {
                name: 'description',
                content: desc
              },
              {
                property: 'og:url',
                content: url
              },
              {
                property: 'og:title',
                content: title
              },
              {
                property: 'og:description',
                content: desc
              },
              {
                property: 'og:image',
                content: 'https://pursuing.business/assets/img/blog/businesscard.JPG'
              }
            ]
          }} ]
});

export default router



// WEBPACK FOOTER //
// ./src/router/router.js